/**
 * The smooth open/close under a SectionToggle: the height animates from 0 to
 * its content (grid rows 0fr → 1fr) with a fade; nothing is unmounted, so a
 * section re-opens where it was. Closed, it is `inert` — nothing inside can
 * be tabbed to or read out. Reduced motion skips the animation.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, ReactNode, useEffect, useRef } from 'react';

import { cn } from '@/lib/utils';

export const Collapse: FC<{ open: boolean; children: ReactNode }> = ({ open, children }) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    ref.current?.toggleAttribute('inert', !open);
  }, [open]);
  return (
    <div
      ref={ref}
      className={cn(
        'grid transition-[grid-template-rows,opacity] duration-300 ease-out motion-reduce:transition-none',
        open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0',
      )}
      aria-hidden={!open}
    >
      <div className="min-h-0 overflow-hidden">{children}</div>
    </div>
  );
};
